import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import ThemeToggle from "@/components/ThemeToggle";
import { ArrowLeft } from "lucide-react";

function LegalLayout({ title, children, kicker = "Légal" }) {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="sticky top-4 z-50 px-4">
        <div className="max-w-4xl mx-auto glass-strong rounded-full border border-border h-14 flex items-center justify-between px-4">
          <Link to="/"><Logo size={20} /></Link>
          <ThemeToggle />
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-16 lg:py-24">
        <Link to="/" className="inline-flex items-center text-sm text-muted-foreground hover:text-foreground mb-8 transition-colors">
          <ArrowLeft className="h-3.5 w-3.5 mr-1.5" />Retour
        </Link>
        <p className="text-xs uppercase tracking-[0.25em] font-bold text-primary mb-3">{kicker}</p>
        <h1 className="text-4xl sm:text-5xl font-black font-display tracking-tighter mb-3">{title}</h1>
        <p className="text-sm text-muted-foreground mb-12">Dernière mise à jour : 1er février 2026</p>
        <div className="prose prose-sm max-w-none space-y-6 text-foreground/90 [&_h2]:font-display [&_h2]:font-black [&_h2]:tracking-tight [&_h2]:text-2xl [&_h2]:mt-10 [&_h2]:mb-3 [&_p]:leading-relaxed [&_p]:text-muted-foreground [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1.5 [&_li]:text-muted-foreground">
          {children}
        </div>
      </main>
      <footer className="border-t border-border py-8 px-6 text-center text-xs text-muted-foreground">
        © 2026 Local Pulse · Fait en France · <Link to="/privacy" className="hover:text-foreground">Confidentialité</Link> · <Link to="/terms" className="hover:text-foreground">CGU</Link> · <Link to="/contact" className="hover:text-foreground">Contact</Link>
      </footer>
    </div>
  );
}

export function Privacy() {
  return (
    <LegalLayout title="Politique de confidentialité" kicker="RGPD">
      <p>Local Pulse SAS attache la plus grande importance à la protection de vos données personnelles. Cette politique décrit comment nous collectons, utilisons et protégeons vos informations.</p>
      <h2>Données collectées</h2>
      <ul>
        <li>Identité : nom, email, mot de passe (haché bcrypt)</li>
        <li>Données business : nom de votre commerce, adresse, liens vers vos profils sociaux</li>
        <li>Contenus rédigés et publications planifiées</li>
        <li>Données de paiement (gérées exclusivement par Stripe)</li>
      </ul>
      <h2>Utilisation</h2>
      <p>Vos données sont utilisées exclusivement pour fournir le service Local Pulse : auditer votre visibilité, rédiger vos contenus, planifier vos publications. Nous ne revendons jamais vos données.</p>
      <h2>Hébergement</h2>
      <p>Toutes vos données sont hébergées en Europe (Paris, France). Aucune donnée ne quitte le territoire européen sans votre consentement explicite.</p>
      <h2>Vos droits</h2>
      <ul>
        <li>Accès, rectification, suppression de vos données depuis votre espace Paramètres</li>
        <li>Export complet de vos données (RGPD)</li>
        <li>Droit d'opposition au traitement à tout moment</li>
      </ul>
      <h2>Contact DPO</h2>
      <p>Pour toute question : support@getlocalpulse.fr</p>
    </LegalLayout>
  );
}

export function Terms() {
  return (
    <LegalLayout title="Conditions générales" kicker="CGU">
      <p>Bienvenue chez Local Pulse. En utilisant nos services, vous acceptez les présentes conditions.</p>
      <h2>Description du service</h2>
      <p>Local Pulse est une plateforme de croissance pour commerces locaux : audit de visibilité, studio de contenu, calendrier éditorial, suivi de la performance.</p>
      <h2>Abonnement</h2>
      <ul>
        <li>Plan Free : gratuit à vie, sans engagement.</li>
        <li>Plans Pro et Business : sans engagement, annulables en un clic.</li>
        <li>Essai gratuit de 7 jours sur tout abonnement payant — annulation libre.</li>
      </ul>
      <h2>Paiement</h2>
      <p>Les paiements sont gérés exclusivement par Stripe. Aucune donnée bancaire n'est stockée sur nos serveurs.</p>
      <h2>Résiliation</h2>
      <p>Vous pouvez résilier à tout moment depuis votre espace Abonnement. La résiliation prend effet à la fin de la période en cours.</p>
      <h2>Responsabilité</h2>
      <p>Local Pulse fournit un outil ; les résultats dépendent de l'application des recommandations par le commerce. Aucune garantie de résultat absolue n'est fournie.</p>
      <h2>Droit applicable</h2>
      <p>Droit français. Tout litige relève de la compétence exclusive des tribunaux de Paris.</p>
    </LegalLayout>
  );
}
